// minimise the border width and add focus ring to the form fields
export const subtleFormClass =
  "border-[0.5px] focus-visible:ring-1 focus-visible:ring-offset-0";
